import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, FreeMode, Pagination, Thumbs, EffectFade, Autoplay } from "swiper";
import { Link } from "react-router-dom";
const ClientAreaFour = () => {
  return (
    <div className="client-area-3">
      {/* <div className="about1-shape-img shape-mockup">
            <img className="about1-shape-img-1 spin" src={`${process.env.PUBLIC_URL}/assets/img/normal/about_shape1-2.svg`} alt="img" />
            <img className="about1-shape-img-2 spin2" src={`${process.env.PUBLIC_URL}/assets/img/normal/about_shape1-1.svg`} alt="img" />
        </div> */}
      <div className="container">
        <div className="row gx-80">
          <div className="col-lg-12">
            <div className="client-slider3">
              <div className="title-area">
                <h4 className="sec-title text-dark text-center">Brands we Trust</h4>
              </div>
              <Swiper
                navigation={{
                  nextEl: ".team-slider2-next",
                  prevEl: ".team-slider2-prev",
                }}
                spaceBetween={20}
                slidesPerGroup={1}
                speed={1000}
                pagination={{ clickable: true }}
                loop
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                className="mySwiper"
                modules={[FreeMode, Navigation, Thumbs, EffectFade, Autoplay]}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  992: {
                    slidesPerView: 4,
                  },
                  1200: {
                    slidesPerView: 5,
                  },
                  1400: {
                    slidesPerView: 5,
                  },
                }}
              >
                <SwiperSlide>
                  <div className="brandslider">
                    <div className="category-card-item">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/update-img/client/1-1.png`}
                        alt="Fixturbo"
                      />
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brandslider">
                    <div className="category-card-item">
                      <img
                    src={`${process.env.PUBLIC_URL}/assets/img/update-img/client/1-2.png`}
                        alt="Fixturbo"
                      />
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brandslider">
                    <div className="category-card-item">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/update-img/client/1-3.png`}
                        alt="Fixturbo"
                      />
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brandslider">
                    <div className="category-card-item">
                      <img
                       src={`${process.env.PUBLIC_URL}/assets/img/update-img/client/1-4.png`}
                        alt="Fixturbo"
                      />
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brandslider">
                    <div className="category-card-item">
                      <img
                     src={`${process.env.PUBLIC_URL}/assets/img/update-img/client/1-5.png`}
                        alt="Fixturbo"
                      />
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brandslider">
                    <div className="category-card-item">
                      <img
                       src={`${process.env.PUBLIC_URL}/assets/img/update-img/client/1-6.png`}
                        alt="Fixturbo"
                      />
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brandslider">
                    <div className="category-card-item">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/update-img/client/1-7.png`}
                        alt="Fixturbo"
                      />
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brandslider">
                    <div className="category-card-item">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/update-img/client/BMW.png`}
                        alt="Fixturbo"
                      />
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brandslider">
                    <div className="category-card-item">
                      <img
                       src={`${process.env.PUBLIC_URL}/assets/img/update-img/client/Jaguar.png`}
                        alt="Fixturbo"
                      />
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brandslider">
                    <div className="category-card-item">
                      <img
                       src={`${process.env.PUBLIC_URL}/assets/img/update-img/client/Ford.png`}
                        alt="Fixturbo"
                      />
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="brandslider">
                    <div className="category-card-item">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/update-img/client/toyota.png`}
                        alt="Fixturbo"
                      />
                    </div>
                  </div>
                </SwiperSlide>
               
               
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientAreaFour;
